import PropTypes from 'prop-types';
import { lazy, useContext } from 'react';
import { DomainContext } from '../../../context';

const HubApplication = lazy(() => import('./HubApplication/Join'));
const SignupWorkflow = lazy(() => import('./SignupWorkflow/SignupWorkflow'));

const SignupRoot = ({ location, history }) => {
    const {
        domainData: { client, isLive },
    } = useContext(DomainContext);
    if (Number(client.id) === 179 && location.search.indexOf('__clt=') === -1) {
        if (process.env.SERVER_ENV === 'production') {
            window.location = 'https://partners.humnutrition.com/';
        } else {
            window.location = 'https://partners-stg.humnutrition.com/';
        }
        return null;
    }
    if (Number(client.id) !== 1 && isLive) {
        return <HubApplication location={location} history={history} />;
    }
    return <SignupWorkflow location={location} history={history} />;
};

SignupRoot.propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
};

export default SignupRoot;
